import { PropsWithChildren } from 'react';
import { StyledUl } from './styled';

export type Variant = 'large' | 'medium' | 'small';

export type ListProps = PropsWithChildren<{
  variant?: Variant;
}>;

export function List({
  children,
  variant = 'medium'
}: ListProps): JSX.Element | null {
  if (Array.isArray(children)) {
    return (
      <StyledUl variant={variant}>
        {children.map((child, index) => (
          <li key={child.toString() + index}>{child}</li>
        ))}
      </StyledUl>
    );
  } else {
    return null;
  }
}
